import { render, staticRenderFns } from "./IconRequestCode.vue?vue&type=template&id=022523d3&scoped=true"
import script from "./IconRequestCode.vue?vue&type=script&lang=js"
export * from "./IconRequestCode.vue?vue&type=script&lang=js"
import style0 from "./IconRequestCode.vue?vue&type=style&index=0&id=022523d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022523d3",
  null
  
)

export default component.exports